import { createHash } from 'crypto';
import { BACKEND_URL } from 'shared-values';

function getEncData(mid: string, ediDate: string, goodsAmt: string, merchantKey: string) {
  return createHash('sha256')
    .update(mid + ediDate + goodsAmt + merchantKey)
    .digest('hex');
}

export interface PaymentFormFieldsProps {
  mid: string;
  ordNo: string;
  goodsAmt: string;
  receipt: Omit<ReceiptData, 'id'>;
  user?: {
    uid: string;
    realName?: string;
    name?: string;
    phoneNum?: string;
    email?: string;
  };
  ordNm: string;
  ordTel: string;
  ordEmail: string;
  ediDate: string;
  merchantKey: string;
  couponIds: string;
  isTogetherEvent: boolean;
  addressString: string;
  userId: string;
  mbsUsrId: string;
}

export function KISPGPaymentFormFields({
  mid,
  ordNo,
  goodsAmt,
  receipt,
  ordNm,
  ordTel,
  ordEmail,
  ediDate,
  merchantKey,
  couponIds,
  isTogetherEvent,
  addressString,
  userId,
  mbsUsrId,
}: PaymentFormFieldsProps) {
  const returnUrl = `${BACKEND_URL}/purchase/complete-simulation?couponIds=${couponIds}&userId=${userId}&isTogetherEvent=${isTogetherEvent}`;
  const encData = getEncData(mid, ediDate, goodsAmt, merchantKey);
  return (
    <>
      <input type="hidden" name="payMethod" value="card" />
      <input type="hidden" name="trxCd" value="0" />
      <input type="hidden" name="mid" value={mid} />
      <input
        type="hidden"
        name="goodsNm"
        value={`${receipt.academyName} (${receipt.lessonName})`}
      />
      <input type="hidden" name="ordNo" value={ordNo} />
      <input type="hidden" name="goodsAmt" value={goodsAmt} />
      <input type="hidden" name="ordNm" value={ordNm} />
      <input type="hidden" name="ordTel" value={ordTel} />
      <input type="hidden" name="ordEmail" value={ordEmail} />
      <input type="hidden" name="returnUrl" value={returnUrl} />
      <input type="hidden" name="userIp" value="0:0:0:0:0:0:0:1" />
      <input type="hidden" name="mbsUsrId" value={mbsUsrId} />
      <input type="hidden" name="ordGuardEmail" value="" />
      <input type="hidden" name="rcvrAddr" value={addressString} />
      <input type="hidden" name="rcvrPost" value="00100" />
      <input type="hidden" name="mbsIp" value="127.0.0.1" />
      <input type="hidden" name="mbsReserved" value={''} />
      <input type="hidden" name="rcvrMsg" value="rcvrMsg" />
      <input type="hidden" name="goodsSplAmt" value="0" />
      <input type="hidden" name="goodsVat" value="0" />
      <input type="hidden" name="goodsSvsAmt" value="0" />
      <input type="hidden" name="payReqType" value="1" />
      <input type="hidden" name="model" value="WEB" />
      <input type="hidden" name="charSet" value="UTF-8" />
      <input type="hidden" name="ediDate" value={ediDate} />
      <input type="hidden" name="encData" value={encData} />
    </>
  );
}
